import React, { Component, useEffect, useState } from 'react'
import { Drawer, Button, Form, Input, DatePicker, message, notification, Card, Row, Col } from 'antd'
import moment from 'moment'
import { updatePaymentApi } from '../api/subscriptionEdits'
import { useDispatch } from 'react-redux'
import { paymentModeList } from '../../../components/_utils/appUtils'
import GetEachFormFields from '../../../components/_utils/appFormUtils'


const EditPaymentDrawer = (props) => {
  let { form, visible, onClose, data = {}, onSuccess } = props
  let { setFieldsValue, getFieldValue, getFieldDecorator } = form
  let [discountAmount, setDiscountAmount] = useState(0)
  let dispatch = useDispatch()

  useEffect(() => {
    setFormData()
  }, [data])
  const setFormData = async () => {
    let { paymentDetails = {} } = data
    setTimeout(() => {
      form.setFieldsValue({
        receivedDate: paymentDetails.receivedDate ? moment(paymentDetails.receivedDate) : null,
        modeOfPayment: paymentDetails.modeOfPayment,
        transactionId: paymentDetails.transactionId,
        amount: paymentDetails.amount,
        discount: paymentDetails.discount,
        netAmount: paymentDetails.netAmount
      })
    }, 100)
  }


  const handleSubmit = (e) => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (!err) {
        const payload = {
          paymentId: data._id,
          ...values,
          discountAmount
        }
        const { error } = await dispatch(updatePaymentApi(payload))
        onSuccess()
        onClose()
        if (!error) {
          message.success('Payment Updated Successfully')
        } else {
          message.error('Failed to update payment')
        }
      }
    })
  }

  const calculateNetAmount = () => {
    let amount = getFieldValue('amount')
    let discount = getFieldValue('discount')
    let discountAmount = ((amount * discount) / 100) || 0
    let netAmount = (amount - discountAmount) || amount
    setDiscountAmount(discountAmount)
    setFieldsValue({
      netAmount, discountAmount
    })
  }

  useEffect(() => {
    calculateNetAmount()
  }, [getFieldValue('amount'), getFieldValue('discount')])


  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const inputSchma = {
    paymentFields: [
      {
        label: 'Received Date',
        key: 'receivedDate',
        required: true,
        placeholder: 'Received Date',
        type: 'date'
      },
      {
        label: 'Mode Of Payment',
        key: 'modeOfPayment',
        required: true,
        placeholder: 'Mode Of Payment',
        type: 'select',
        options: paymentModeList,
        allowClear: true,
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: (val) => {
          setFieldsValue({ modeOfPayment: val })
        }
      },
      {
        label: 'Transaction/Cheque ID',
        key: 'transactionId',
        required: false,
        placeholder: 'Enter Transaction/Cheque ID',
        disabled: true
      }
    ],
    amountFields: [
      {
        label: 'Amount',
        key: 'amount',
        required: true,
        placeholder: 'Amount',
        type: 'number'
      },
      {
        label: 'Discount (In Percentage)',
        key: 'discount',
        placeholder: 'Discount',
        type: 'number'
      },
      {
        label: 'Net Amount',
        key: 'netAmount',
        required: true,
        placeholder: 'Net Amount',
        disabled: true,
        type: 'number'
      }
    ]
  }
  return (
    <Drawer
      title={'Update Payment Details'}
      width={'45%'}
      visible={visible}
      maskClosable={true}
      placement='right'
      onClose={onClose}>
      <Card bordered={true}>
        <Form
          onSubmit={handleSubmit}
          hideRequiredMark
          noValidate={true}
          className={'inputForm'}>
          <Card bordered={true} size={'small'}>
            <Row gutter={16}>
              {inputSchma.paymentFields.map((item, key) => {
                return (
                  <Col span={item.span ? item.span : 12}
                       md={item.span ? item.span : 12}
                       sm={12}
                       xs={24}
                       key={key}>
                    <GetEachFormFields
                      item={item}
                      getFieldDecorator={getFieldDecorator}
                      formItemLayout={formItemLayout}
                    />
                  </Col>
                )
              })}
            </Row>
            <hr className={'hr-color'} />
            <Row gutter={16} className={'mt10'}>
              {inputSchma.amountFields.map((item, key) => {
                return (
                  <Col span={8}
                       md={8}
                       sm={12}
                       xs={24}
                       key={key}>
                    <GetEachFormFields
                      item={item}
                      getFieldDecorator={getFieldDecorator}
                      formItemLayout={formItemLayout}
                    />
                  </Col>
                )
              })}
            </Row>
          </Card>


          <Form.Item style={{ marginTop: 10 }}>
            <Button type='primary' htmlType='submit'>
              SUBMIT
            </Button>
          </Form.Item>
        </Form>


      </Card>
    </Drawer>
  )
}

const WrappedEditPaymentDrawer = Form.create()(EditPaymentDrawer)
export default WrappedEditPaymentDrawer
